export function addUnbreakableSpace(text: string) {
  const characters = ['?', '!', ':', ';'];
  let newText = text;
  for (const char of characters) {
    const searchValue = `\\s\\${char}`;
    const searchRegExp = new RegExp(searchValue, 'g');
    newText = newText.replace(searchRegExp, `\u00A0${char}`);
  }
  return newText;
}

export function changeParameterInString(
  str: string,
  paramToReplace: string,
  replacedBy: string,
  separator: string,
): string {
  const arrayString = str.split(separator);
  return arrayString
    .map((s: any) => {
      const urlSrc = new URL(s);
      const params = new URLSearchParams(urlSrc.search);
      params.set(paramToReplace, replacedBy);
      urlSrc.search = params.toString();
      return urlSrc;
    })
    .join(separator);
}
